// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Prism Theme with CSS Variables for Light/Dark Mode */

:root {
    /* Default (Light Mode) - Based on Prism Default */
    --prism-bg: #ffffff;
    --prism-text: black;
    --prism-comment: #708090;
    --prism-punctuation: #999;
    --prism-tag: #905;
    --prism-attr-value: #690;
    --prism-operator: #9a6e3a;
    --prism-keyword: #07a;
    --prism-function: #dd4a68;
    --prism-number: #905;
    --prism-class-name: #dd4a68;
    --prism-regex: #e90;
    --prism-variable: #e90;
    --prism-header: #999;
    /* For Markdown AST if rendered */
}

html.dark {
    /* Dark Mode - Based on Prism Tomorrow Night */
    --prism-bg: #2d2d2d;
    --prism-text: #ccc;
    --prism-comment: #999;
    --prism-punctuation: #ccc;
    --prism-tag: #e2777a;
    --prism-attr-value: #7ec699;
    --prism-operator: #67cdcc;
    --prism-keyword: #cc99cd;
    --prism-function: #6196cc;
    --prism-number: #f08d49;
    --prism-class-name: #f8c555;
    --prism-regex: #7ec699;
    --prism-variable: #f8c555;
    --prism-header: #ccc;
}

/* Core setup */
code[class*="language-"],
pre[class*="language-"] {
    color: var(--prism-text);
    background: none;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 1em;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 1.5;

    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;
    hyphens: none;
}

/* Code blocks */
pre[class*="language-"] {
    padding: 1em;
    margin: .5em 0;
    overflow: auto;
    border-radius: 0.3em;
    background: var(--prism-bg);
    /* Only pre gets background */
}

/* Inline code */
:not(pre)>code[class*="language-"] {
    padding: .1em;
    border-radius: .3em;
    white-space: normal;
    background: var(--prism-bg);
}

.token.comment,
.token.block-comment,
.token.prolog,
.token.doctype,
.token.cdata {
    color: var(--prism-comment);
}

.token.punctuation {
    color: var(--prism-punctuation);
}

.token.namespace {
    opacity: .7;
}

.token.property,
.token.tag,
.token.constant,
.token.symbol,
.token.deleted {
    color: var(--prism-tag);
}

.token.boolean,
.token.number {
    color: var(--prism-number);
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
    color: var(--prism-attr-value);
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
    color: var(--prism-operator);
}

.token.atrule,
.token.attr-value,
.token.keyword {
    color: var(--prism-keyword);
}

.token.function,
.token.class-name {
    color: var(--prism-function);
}

.token.regex,
.token.important,
.token.variable {
    color: var(--prism-regex);
}

.token.important,
.token.bold {
    font-weight: bold;
}

.token.italic {
    font-style: italic;
}

.token.entity {
    cursor: help;
}

/* Dark mode specific tweaks for specific tokens that need mapping adjustments */
html.dark .token.operator,
html.dark .token.entity,
html.dark .token.url {
    color: var(--prism-operator);
    /* #67cdcc */
}

html.dark .token.string,
html.dark .token.char,
html.dark .token.attr-value {
    color: var(--prism-attr-value);
    /* #7ec699 */
}`, "",{"version":3,"sources":["webpack://./src/styles/prism-custom-theme.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;IACI,kDAAkD;IAClD,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,2BAA2B;IAC3B,yBAAyB;IACzB,wBAAwB;IACxB,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA,eAAe;AACf;;IAEI,wBAAwB;IACxB,gBAAgB;IAChB,+GAA+G;IAC/G,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;;IAEhB,gBAAgB;IAChB,cAAc;IACd,WAAW;IAKX,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,YAAY;IACZ,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;;;;IAKI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;IAKI,uBAAuB;AAC3B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;;;;;IAMI,8BAA8B;AAClC;;AAEA;;;;;IAKI,4BAA4B;AAChC;;AAEA;;;IAGI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA,gFAAgF;AAChF;;;IAGI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;;;IAGI,8BAA8B;IAC9B,YAAY;AAChB","sourcesContent":["/* Custom Prism Theme with CSS Variables for Light/Dark Mode */\r\n\r\n:root {\r\n    /* Default (Light Mode) - Based on Prism Default */\r\n    --prism-bg: #ffffff;\r\n    --prism-text: black;\r\n    --prism-comment: #708090;\r\n    --prism-punctuation: #999;\r\n    --prism-tag: #905;\r\n    --prism-attr-value: #690;\r\n    --prism-operator: #9a6e3a;\r\n    --prism-keyword: #07a;\r\n    --prism-function: #dd4a68;\r\n    --prism-number: #905;\r\n    --prism-class-name: #dd4a68;\r\n    --prism-regex: #e90;\r\n    --prism-variable: #e90;\r\n    --prism-header: #999;\r\n    /* For Markdown AST if rendered */\r\n}\r\n\r\nhtml.dark {\r\n    /* Dark Mode - Based on Prism Tomorrow Night */\r\n    --prism-bg: #2d2d2d;\r\n    --prism-text: #ccc;\r\n    --prism-comment: #999;\r\n    --prism-punctuation: #ccc;\r\n    --prism-tag: #e2777a;\r\n    --prism-attr-value: #7ec699;\r\n    --prism-operator: #67cdcc;\r\n    --prism-keyword: #cc99cd;\r\n    --prism-function: #6196cc;\r\n    --prism-number: #f08d49;\r\n    --prism-class-name: #f8c555;\r\n    --prism-regex: #7ec699;\r\n    --prism-variable: #f8c555;\r\n    --prism-header: #ccc;\r\n}\r\n\r\n/* Core setup */\r\ncode[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    color: var(--prism-text);\r\n    background: none;\r\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n    font-size: 1em;\r\n    text-align: left;\r\n    white-space: pre;\r\n    word-spacing: normal;\r\n    word-break: normal;\r\n    word-wrap: normal;\r\n    line-height: 1.5;\r\n\r\n    -moz-tab-size: 4;\r\n    -o-tab-size: 4;\r\n    tab-size: 4;\r\n\r\n    -webkit-hyphens: none;\r\n    -moz-hyphens: none;\r\n    -ms-hyphens: none;\r\n    hyphens: none;\r\n}\r\n\r\n/* Code blocks */\r\npre[class*=\"language-\"] {\r\n    padding: 1em;\r\n    margin: .5em 0;\r\n    overflow: auto;\r\n    border-radius: 0.3em;\r\n    background: var(--prism-bg);\r\n    /* Only pre gets background */\r\n}\r\n\r\n/* Inline code */\r\n:not(pre)>code[class*=\"language-\"] {\r\n    padding: .1em;\r\n    border-radius: .3em;\r\n    white-space: normal;\r\n    background: var(--prism-bg);\r\n}\r\n\r\n.token.comment,\r\n.token.block-comment,\r\n.token.prolog,\r\n.token.doctype,\r\n.token.cdata {\r\n    color: var(--prism-comment);\r\n}\r\n\r\n.token.punctuation {\r\n    color: var(--prism-punctuation);\r\n}\r\n\r\n.token.namespace {\r\n    opacity: .7;\r\n}\r\n\r\n.token.property,\r\n.token.tag,\r\n.token.constant,\r\n.token.symbol,\r\n.token.deleted {\r\n    color: var(--prism-tag);\r\n}\r\n\r\n.token.boolean,\r\n.token.number {\r\n    color: var(--prism-number);\r\n}\r\n\r\n.token.selector,\r\n.token.attr-name,\r\n.token.string,\r\n.token.char,\r\n.token.builtin,\r\n.token.inserted {\r\n    color: var(--prism-attr-value);\r\n}\r\n\r\n.token.operator,\r\n.token.entity,\r\n.token.url,\r\n.language-css .token.string,\r\n.style .token.string {\r\n    color: var(--prism-operator);\r\n}\r\n\r\n.token.atrule,\r\n.token.attr-value,\r\n.token.keyword {\r\n    color: var(--prism-keyword);\r\n}\r\n\r\n.token.function,\r\n.token.class-name {\r\n    color: var(--prism-function);\r\n}\r\n\r\n.token.regex,\r\n.token.important,\r\n.token.variable {\r\n    color: var(--prism-regex);\r\n}\r\n\r\n.token.important,\r\n.token.bold {\r\n    font-weight: bold;\r\n}\r\n\r\n.token.italic {\r\n    font-style: italic;\r\n}\r\n\r\n.token.entity {\r\n    cursor: help;\r\n}\r\n\r\n/* Dark mode specific tweaks for specific tokens that need mapping adjustments */\r\nhtml.dark .token.operator,\r\nhtml.dark .token.entity,\r\nhtml.dark .token.url {\r\n    color: var(--prism-operator);\r\n    /* #67cdcc */\r\n}\r\n\r\nhtml.dark .token.string,\r\nhtml.dark .token.char,\r\nhtml.dark .token.attr-value {\r\n    color: var(--prism-attr-value);\r\n    /* #7ec699 */\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
